
var resolution = {
	Set: null,
	Switch: null,
	orientation: null,
	current: null,
	first: true
}
// cache bust

// Media Carousel:
var mediaCarousel = 0;
var mediaCurrentSlide = 0;
var mediaTotalImages = 0;
var mediaImagesLoaded = false;
var mediaCarouselStat = 'hide';
var firstMediaCarousel = true;
function loadMediaImages() {
	if (mediaImagesLoaded == false) {
		$('#media_caroussel ul li').each(function (i) {
			mediaTotalImages = i + 1;
		});
		$('#media_caroussel ul li img').each(function (i) {
			$(this).attr('src', $(this).attr('data-src'));
			if (i + 1 == mediaTotalImages) {
				$(this).load(function () {
					mediaImagesLoaded = true;
				});
			}
		});
	}
}

function mediaCarouselFunc(resize) {
	if ($('#media_caroussel').length != '') {
		if ($(window).width() >= 768) {
			if ((resize == true && mediaCarouselStat == 'show') || resize == false) {
				var timeout = 0;
				if (mediaImagesLoaded != true) {
					loadMediaImages();
					timeout = 1000;
				}
				if (mediaCarouselStat == 'hide') {
					$('#media_caroussel_bg .loader').stop().css({ 'opacity': 1 });
					$('#media_caroussel_bg').stop().show().animate({ 'opacity': 1 }, 800);
					$('#media_caroussel, #media_caroussel_cont').stop().show();
				}
				setTimeout(function () {
					if (firstMediaCarousel == true) {
						firstMediaCarousel = false;
					} else {
						mediaCarousel.destroySlider();
						$('#media_caroussel ul li').each(function () {
							$(this).removeAttr('style');
							$(this).find('img').removeAttr('style');
						});
					}

					var slideWidth = 900;
					if ($(window).width() > 1800 && $(window).height() > 900) {
						slideWidth = 1100;
					}
					if ($(window).width() > 1020 && $(window).width() <= 1420) {
						slideWidth = 630;
					}
					if ($(window).width() >= 768 && $(window).width() <= 1020) {
						slideWidth = 520;
					}
					// if ($(window).width() < slideWidth) { slideWidth = $(window).width(); }
					var slideMargin = 180;
					if ($(window).width() < 768) {
						slideWidth = 280;
						slideMargin = 20;
					}
					var slideHeight = parseInt($('#media_caroussel ul li img').height());
					mediaCarousel = $('#media_caroussel ul').bxSlider({
						mode: 'horizontal',
						speed: 600,
						startSlide: mediaCurrentSlide,
						infiniteLoop: true,
						slideWidth: slideWidth,
						minSlides: 1,
						maxSlides: 5,
						moveSlides: 1,
						slideMargin: slideMargin,
						captions: false,
						touchEnabled: true,
						pager: true,
						buildPager: function (slideIndex) {
							var slide = slideIndex + 1;
							return slide + '<sub> / ' + mediaTotalImages + '</sub>';
						},
						controls: true,
						nextText: '<div class="icon icon-next"><i class="svg-icon" data-icon="icon-arrow" data-fill="#ffffff"></i></div>',
						prevText: '<div class="icon icon-prev"><i class="svg-icon" data-icon="icon-arrow" data-fill="#ffffff" data-rotate="180"></i></div>',
						adaptiveHeight: true,
						onSliderLoad: function (currentIndex) {
							var tempIndex = currentIndex + 1;
							$('body').icons.init('.svg-icon');
						},
						onSlideAfter: function ($slideElement, oldIndex, newIndex) {
							mediaCurrentSlide = newIndex;
							var tempIndex = newIndex + 1;
							$('#media_caroussel ul li').removeClass('active');
							$slideElement.addClass('active');
						}
					});
					$('#media_caroussel ul li img').each(function () {
						var left = ($(window).width() - slideWidth) / 2;
						$(this).css({ 'left': left });
					});
					var top = ($(window).height() - slideHeight - $('#dock').height()) / 2;
					if ($(window).width() < 768) { top = ($(window).height() - slideHeight) / 2; }
					$('#media_caroussel').css({ 'top': top });
					$('#media_caroussel .bx-wrapper .bx-controls .bx-controls-direction').prepend('<div class="close"><i class="svg-icon" data-icon="icon-close" data-fill="#ffffff"></i></div>');
					if (mediaCarouselStat == 'hide') {
						setTimeout(function () {
							$('#media_caroussel').stop().animate({ 'opacity': 1 }, 800);
							$('#media_caroussel_bg .loader').stop().animate({ 'opacity': 0 }, 800);
							mediaCarouselStat = 'show';
							$('body').icons.init('.svg-icon');
						}, 100);
					}
					if ($(window).height() - $('#dock').height() < slideHeight) {
						var marginTop = (top - (2 * top)) + 50;
						$('#media_caroussel .close').css({ 'margin-top': marginTop });
					}
				}, timeout);
			}
		} else {
			mediaCarousel.destroySlider();
			$('#media_caroussel ul li').each(function () {
				$(this).removeAttr('style');
				$(this).find('img').removeAttr('style');
			});
			mediaCarouselStat = 'hide';
			lockScroll(false);
			$('#media_caroussel_cont, #media_caroussel, #media_caroussel_bg').removeAttr('style');
		}
	}
}

$.fn.isAfter = function (sel) {
	return this.prevAll(sel).length !== 0;
}
$.fn.isBefore = function (sel) {
	return this.nextAll(sel).length !== 0;
}
$(document).on('click', '#media_caroussel.active ul li img', function (e) {
	if (!$(this).parent().hasClass('active')) {
		if ($(this).parent().isAfter("#media_caroussel ul li.active")) {
			mediaCarousel.goToNextSlide();
		}
		if ($(this).parent().isBefore("#media_caroussel ul li.active")) {
			mediaCarousel.goToPrevSlide();
		}
	}
});

// lockScroll
var pos = "0";
var handler = function () {
	$('html, body').scrollTop(pos);
};
var lockScroll = function (stat) {
	var FF = !(window.mozInnerScreenX == null);
	if (FF == false) {
		if (stat == true) {
			$(window).bind('scroll', handler);
			document.onmousewheel = function () { stopWheel(); } /* IE7, IE8 */
			if (document.addEventListener) { /* Chrome, Safari, Firefox */
				document.addEventListener('DOMMouseScroll', stopWheel, false);
			}
			function stopWheel(e) {
				if (!e) { e = window.event; } /* IE7, IE8, Chrome, Safari */
				if (e.preventDefault) { e.preventDefault(); } /* Chrome, Safari, Firefox */
				e.returnValue = false; /* IE7, IE8 */
			}
		} else {
			$(window).unbind('scroll', handler);
			document.onmousewheel = null;  /* IE7, IE8 */
			if (document.addEventListener) { /* Chrome, Safari, Firefox */
				document.removeEventListener('DOMMouseScroll', stopWheel, false);
			}
		}
	} else {
		if (stat == true) {
			$(window).bind('scroll', handler);
		} else {
			$(window).unbind('scroll', handler);
		}
	}
	if ($('html').hasClass('touch')) {
		if (stat == true) {
			document.ontouchmove = function (e) { e.preventDefault(); }
		} else {
			document.ontouchmove = function (e) { return true; }
		}
	}
}



$(function () {

	// parallax quote
	if ($('#overzicht').length > 0 && !$('html').hasClass('touch')) {
		// for each quote binnen event item
		// opacity op 0
		// top - aantal?

		// op scroll: als event item op bepaalde positie staat:
		// quote laten scrollen.

	}

	// ===================================================================================

	//[Scroller]
	var scroller = {
		'first': true,
		'loaded': true,
		'checks': {
			'overzicht': false,
		},
		'init': null,
		'resize': null,
		'items': {
			'overzicht': {
				'changed': false,
			},
		},
		'pos': {
			'curr': null,
			'last': null,
			'dir': null,
		},
		'RAF': {
			'ID': null,
			'start': null,
			'stop': null,
			'loop': null,
		},
		'callculation': null,
		'animation': null,
		'longScroll': false,
	};

	scroller.init = function (resize) {

		if ($('#overzicht').length > 0) {
			scroller.checks.overzicht = true;
		}
		if (scroller.checks.overzicht == true) {
			scroller.items.overzicht = {
				'quotes': [],
				'isTouch': ($('html').hasClass('touch')) ? true : false,
			}
			$('.overzicht .widget').each(function () {
				scroller.items.overzicht.quotes.push($(this));
			});
			for (q in scroller.items.overzicht.quotes) {
				//console.log(scroller.items.overzicht.quotes[q]);
				var quote = scroller.items.overzicht.quotes[q];
				//quote.css({ 'top' : -100, 'opacity' : 0 });
			}
		}
		scroller.loaded = true;
	}

	scroller.callculation = function (pos) {
		if (scroller.checks.overzicht == true) {
			var quotes = scroller.items.overzicht.quotes;
			//console.log(quotes);
			if (!quotes.isTouch) {
				for (q in quotes) {
					var event = $(quotes[q]).parents('.event'),
						eventPos = event.offset().top;

					if (pos >= eventPos) {
						scroller.items.overzicht.quotes[q].changed = true;
						var scrollHeight = $('#container').height(),
							procent = pos / scrollHeight;
						if (procent > 1) { procent = 1 };
						scroller.items.overzicht.quotes[q].opacity = Math.abs(procent);
					} else {
						scroller.items.overzicht.quotes[q].changed = false;
						scroller.items.overzicht.quotes[q].opacity = 0;
					}
				}
			}
		}
	}

	scroller.animation = function (pos) {
		var quotes = scroller.items.overzicht.quotes;
		if (scroller.checks.overzicht == true) {
			if (!quotes.isTouch) {
				for (q in quotes) {
				}
			}
		}
	}

	scroller.RAF.loop = function () {
		if (!$('body').hasClass('fixed')) {
			scroller.pos.curr = Math.round($(window).scrollTop());
			if (scroller.pos.curr < 0) { scroller.pos.curr = 0; }
			if (scroller.pos.curr > scroller.pos.last) {
				scroller.pos.dir = 'down';
			} else if (scroller.pos.curr < scroller.pos.last) {
				scroller.pos.dir = 'up';
			}
			scroller.callculation(scroller.pos.curr);
			scroller.animation(scroller.pos.curr);
			scroller.pos.last = scroller.pos.curr;
			if (Modernizr.raf) {
				scroller.RAF.ID = window.requestAnimationFrame(scroller.RAF.loop);
			}
		}
	}

	scroller.RAF.start = function () {
		if (!scroller.RAF.ID && scroller.loaded == true) {
			scroller.RAF.loop();
		}
	}

	scroller.RAF.stop = function () {
		if (scroller.RAF.ID) {
			window.cancelAnimationFrame(scroller.RAF.ID);
			scroller.RAF.ID = undefined;
		}
	}
	// ===================================================================================

	// owl carousel:
	function callbackGallery() {

	}

	function rowGallery() {
		$('.owl-carousel--gallery').owlCarousel({
			items: 1,
			nav: true,
			dot: true,
			loop: true,
			itemElement: 'li',
			stageElement: 'ul',
			navText: [
				'<i class="svg-icon" data-icon="icon-arrow" data-fill="#ffffff"></i>',
				'<i class="svg-icon" data-icon="icon-arrow" data-fill="#ffffff"></i>'
			],
			onInitialized: callbackGallery
		});
	}
	rowGallery();

	function heroGallery() {
		var owl = $('.owl-carousel--hero').owlCarousel({
			responsive: {
				0: {
					items: 1,
					dotsEach: 1,
				},
				768: {
					items: 2,
					dotsEach: 1,
				}
			},
			merge: false,
			loop: true,
			margin: 0,
			lazyLoad: true,
			center: false,
			dots: true,
			nav: false,
			onInitialized: callbackGallery
		});

		$('.js-owl-next').on('click', function (e) {
			e.preventDefault();
			owl.trigger('next.owl.carousel');
		});
	}
	heroGallery();



	// open filter on mobile
	function openFilter() {
		var setScrollTop = 0;
		if (Modernizr.mq('(max-width: 767px)') && $('#filter').length > 0) {
			var $overlay = $('.overlay-filter'),
				$filter = $('#filter');
			$('a.btn--filter').on('click', function (e) {
				e.preventDefault;
				var $this = $(this);
				if (!$this.hasClass('active')) {
					setScrollTop = 0;
					$('body').addClass('fixed');
					$('#container').css({ 'position': 'fixed', 'margin-top': -Math.abs(setScrollTop) });
					$this.addClass('active');
					$overlay.fadeIn('fast').addClass('active');
					$filter.fadeIn('fast').addClass('active');
					$('body').icons.init('.svg-icon');
				}
			});
			$('#filter .close, #filter .btn--filter').on('click', function (e) {
				e.preventDefault();
				if ($filter.hasClass('active')) {
					$('body').removeClass('fixed');
					$('#container').removeAttr('style');
					$(window).scrollTop(setScrollTop);
					$('a.btn--filter').removeClass('active');
					$overlay.fadeOut('fast').removeClass('active');
					$filter.fadeOut('fast').removeClass('active');
				}
			});
		}
	}
	openFilter();

	// Do filter
	var filterActivated = false;
	$('#filter .filter>a').click(function (e) {
		e.preventDefault();
		if (!filterActivated) {
			activateFilter();
		}
		var filterName = $(this).attr('data-filter');
		if ($(this).hasClass('active')) {
			filterName = false;
		}
		$(this).parent().find('a').removeClass('active');
		if (filterName) {
			$(this).addClass('active');
		}
		do_filter(true);
	});

	$('#filter a.reset').click(function (e) {
		e.preventDefault();
		if (!filterActivated) {
			activateFilter();
		}
		$('#filter .filter>a').removeClass('active');
		do_filter(true);
	});

	function addFiltersToStrings( filterString1, filterString2, filterString3, filterString4, element ) {
		var filter1 = element.attr( 'data-filter1' );
		var filter2 = element.attr( 'data-filter2' );
		if ( filter2 && filter2 != '.' && filter2.indexOf( '.' ) != -1 ) {
			filter2 = element.attr( 'data-filter2' ).split( '.' );
		} else {
			filter2 = [];
		}
		var filter3 = element.attr( 'data-filter3' );
		var filter4 = element.attr( 'data-filter4' );

		if (filterString1.indexOf('.' + filter1 + '.') == -1) {
			filterString1 += filter1 + '.';
		}

		for (var i = 0; i < filter2.length; i++) {
			if (filter2[i].trim() != '' && filterString2.indexOf('.' + filter2[i] + '.') == -1) {
				filterString2 += filter2[i].trim() + '.';
			}
		}

		if (filterString3.indexOf('.' + filter3 + '.') == -1) {
			filterString3 += filter3 + '.';
		}

		if (filterString4.indexOf('.' + filter4 + '.') == -1) {
			filterString4 += filter4 + '.';
		}

		var result = [filterString1, filterString2, filterString3, filterString4];
		return result;
	}

	function activateFilter() {
		for (var i = 0; i < $('#overzicht>.overzicht').length; i++) {
			var overviewFilter1 = '.';
			var overviewFilter2 = '.';
			var overviewFilter3 = '.';
			var overviewFilter4 = '.';
			for ( var j = 0; j < $( '#overzicht>.overzicht:eq( ' + i + ' ) .event' ).length; j++ ) {
				var result = addFiltersToStrings( overviewFilter1, overviewFilter2, overviewFilter3, overviewFilter4, $( '#overzicht>.overzicht:eq( ' + i + ' ) .event:eq( ' + j + ' )' ) );
				overviewFilter1 = result[0];
				overviewFilter2 = result[1];
				overviewFilter3 = result[2];
				overviewFilter4 = result[3];
			}
			$( '#overzicht>.overzicht:eq( ' + i + ' )' ).attr( 'data-filter1', overviewFilter1 );
			$( '#overzicht>.overzicht:eq( ' + i + ' )' ).attr( 'data-filter2', overviewFilter2 );
			$( '#overzicht>.overzicht:eq( ' + i + ' )' ).attr( 'data-filter3', overviewFilter3 );
			$( '#overzicht>.overzicht:eq( ' + i + ' )' ).attr( 'data-filter4', overviewFilter4 );
		}
		for (var i = 0; i < $('#overzicht>.new-month').length; i++) {
			var monthFilter1 = '.';
			var monthFilter2 = '.';
			var monthFilter3 = '.';
			var monthFilter4 = '.';
			for ( var j = 0; j < $( '#overzicht .new-month:eq( ' + i + ' ) .overzicht' ).length; j++ ) {
				var overviewFilter1 = '.';
				var overviewFilter2 = '.';
				var overviewFilter3 = '.';
				var overviewFilter4 = '.';
				for ( var k = 0; k < $( '#overzicht .new-month:eq( ' + i + ' ) .overzicht:eq( ' + j + ' ) .event' ).length; k++ ) {
					var result = addFiltersToStrings( overviewFilter1, overviewFilter2, overviewFilter3, overviewFilter4, $( '#overzicht .new-month:eq( ' + i + ' ) .overzicht:eq( ' + j + ' ) .event:eq( ' + k + ' )' ) );
					overviewFilter1 = result[0];
					overviewFilter2 = result[1];
					overviewFilter3 = result[2];
					overviewFilter4 = result[3];
					var result = addFiltersToStrings( monthFilter1, monthFilter2, monthFilter3, monthFilter4, $( '#overzicht .new-month:eq( ' + i + ' ) .overzicht:eq( ' + j + ' ) .event:eq( ' + k + ' )' ) );
					monthFilter1 = result[0];
					monthFilter2 = result[1];
					monthFilter3 = result[2];
					monthFilter4 = result[3];
				}
				$( '#overzicht .new-month:eq( ' + i + ' ) .overzicht:eq( ' + j + ' )' ).attr( 'data-filter1', overviewFilter1 );
				$( '#overzicht .new-month:eq( ' + i + ' ) .overzicht:eq( ' + j + ' )' ).attr( 'data-filter2', overviewFilter2 );
				$( '#overzicht .new-month:eq( ' + i + ' ) .overzicht:eq( ' + j + ' )' ).attr( 'data-filter3', overviewFilter3 );
				$( '#overzicht .new-month:eq( ' + i + ' ) .overzicht:eq( ' + j + ' )' ).attr( 'data-filter4', overviewFilter4 );
			}
			$( '#overzicht .new-month:eq( ' + i + ' )' ).attr( 'data-filter1', monthFilter1 );
			$( '#overzicht .new-month:eq( ' + i + ' )' ).attr( 'data-filter2', monthFilter2 );
			$( '#overzicht .new-month:eq( ' + i + ' )' ).attr( 'data-filter3', monthFilter3 );
			$( '#overzicht .new-month:eq( ' + i + ' )' ).attr( 'data-filter4', monthFilter4 );
		}
		filterActivated = true;
	}

	var filterReq = null;
	function do_filter(do_ajax) {
		if ($('#overzicht .no-results:visible').length > 0) {
			$('.no-results').css('display', 'none');
		}

		var filter1 = false;
		var filter2 = false;
		var filter3 = false;
		var filter4 = false;
		var urlFilters = '';
		if ($('#filter .filter1>a.active').length > 0) {
			filter1 = $('#filter .filter1>a.active').attr('data-filter');
			if ('' == urlFilters) {
				urlFilters += '?';
			} else {
				urlFilters += '&';
			}
			urlFilters += 'filter1=' + filter1;
		}
		if ($('#filter .filter2>a.active').length > 0) {
			filter2 = $('#filter .filter2>a.active').attr('data-filter');
			if ('' == urlFilters) {
				urlFilters += '?';
			} else {
				urlFilters += '&';
			}
			urlFilters += 'filter2=' + filter2;
		}
		if ($('#filter .filter3>a.active').length > 0) {
			filter3 = $('#filter .filter3>a.active').attr('data-filter');
			if ('' == urlFilters) {
				urlFilters += '?';
			} else {
				urlFilters += '&';
			}
			urlFilters += 'filter3=' + filter3;
		}
		if ( $( '#filter .filter4>a.active' ).length > 0 ) {
			filter4 = $('#filter .filter4>a.active').attr('data-filter');
			if ('' == urlFilters) {
				urlFilters += '?';
			} else {
				urlFilters += '&';
			}
			urlFilters += 'filter4=' + filter4;
		}
		if ( do_ajax ) {
			filterReq = $.ajax({
				type: 'POST',
				data: urlFilters.substr(1) + '&action=paard_store_filter',
				url: customData.ajaxURL,
				beforeSend: function () {
					if (filterReq != null) {
						filterReq.abort();
					}
				}
			});
		}

		var i = 0;
		var count = $('#overzicht .items .event, #overzicht .overzicht, #overzicht .new-month').length;
		$('#overzicht .items .event, #overzicht .overzicht, #overzicht .new-month').each(function () {
			i++;
			var visible = true;
			var is_event = $(this).hasClass('event');
			if (filter1 && is_event && $(this).attr('data-filter1') != filter1) {
				visible = false;
			} else if (filter1 && !is_event && $(this).attr('data-filter1').indexOf('.' + filter1 + '.') == -1) {
				visible = false;
			}
			if (visible && is_event && filter3 && $(this).attr('data-filter3') != filter3) {
				visible = false;
			} else if (visible && !is_event && filter3 && $(this).attr('data-filter3').indexOf('.' + filter3 + '.') == -1) {
				visible = false;
			}
			if (visible && filter2 && $(this).attr('data-filter2').indexOf('.' + filter2 + '.') == -1) {
				visible = false;
			}
			// console.log($(this).find('.event-item').find('.titles').find('h2').text())
			// console.log(filter4, $(this).attr('data-filter4'))
			if (visible && is_event && filter4 && $(this).attr('data-filter4') != filter4) {
				visible = false;
			} else if (visible && !is_event && filter4 && $(this).attr('data-filter4').indexOf('.' + filter4 + '.') == -1) {
				visible = false;
			}
			if ( ! visible && $( this ).is( ':visible' ) ) {
				$( this ).animate( { opacity: 0 }, 500, function() {
					$( this ).css( 'display', 'none' );
					if ( $( '#overzicht .items .event:visible' ).length == 0 ) {
						$( '.no-results' ).css( 'display', 'block' );
						$( '.no-results' ).animate( { opacity: 1, }, 500 );
					}
				});
			} else if (visible && !$(this).is(':visible')) {
				$(this).css('display', 'block');
				$(this).animate({ opacity: 1, }, 500);
			}
		});

		if ($('#overzicht .items .event:visible').length == 0) {
			$('.no-results').css('display', 'block');
			$('.no-results').animate({ opacity: 1, }, 500);
		}

		var url = document.location.protocol + '//' + document.location.hostname + document.location.pathname;
		window.history.replaceState({}, document.title, url + urlFilters);
	}
	if ($('.post-type-archive-event #overzicht').length > 0 && $('#filter .filter a.active').length > 0) {
		activateFilter();
		do_filter(false);
	}

	// open share
	function openShare() {
		if ($('#share').length > 0) {
			//var $share = $('#share');
			$('#share a.share').on('click', function (e) {
				e.preventDefault();
				$share = $(this).parents('#share');
				if (!$share.hasClass('active')) {
					$share.addClass('active');
				} else {
					$share.removeClass('active');
				}
			});
		}
	}
	openShare();

	// submenu
	function openSubmenuItem() {
		if (Modernizr.mq('(min-width: 768px)') && $('.submenu').length > 0) {
			$('.submenu > ul > li > a').on('click', function (e) {
				if ($(this).parent('li').children('nav').length > 0) {
					e.preventDefault();
					var $this = $(this).parent('li');
					if ($this.hasClass('active')) {
						$this.removeClass('active').find('.subsub').css({ 'max-height': 0 });
					} else {
						setTimeout(function () {
							var newH = $this.find('ul').outerHeight(true);
							$this.addClass('active').find('.subsub').css({ 'max-height': newH });
							$this.siblings('li').removeClass('active').find('.subsub').css({ 'max-height': 0 });
						}, 100);
					}
				}
			});

			if ($('.submenu > ul > li.current-menu-parent, .submenu > ul > li.current-menu-item').length > 0) {
				setTimeout(function () {
					var $li = $('.submenu > ul > li.current-page-parent, .submenu > ul > li.current-menu-item'),
						newH = $li.find('ul').outerHeight(true);
					$li.addClass('active').find('.subsub').css({ 'max-height': newH });
				}, 100);
			}
		}
	}
	openSubmenuItem();

	// submenu
	function openSubmenuItemMobileNav() {
		if (Modernizr.mq('(max-width: 1023px)')) {
			$('.nav li .icon').on('click', function (e) {
				e.preventDefault();
				var $this = $(this).parent('li');
				if ($this.hasClass('active')) {
					$this.removeClass('active').find('.subsub').css({ 'max-height': 0 });
				} else {
					var newH = $this.find('ul').outerHeight(true);
					$this.addClass('active').find('.subsub').css({ 'max-height': newH });
					$this.siblings('li').removeClass('active').find('.subsub').css({ 'max-height': 0 });
				}
			});
		}
	}
	openSubmenuItemMobileNav();

	function openActiveSubItem() {
		if (Modernizr.mq('(max-width: 1023px)')) {
			if ($('.nav > ul > li.current-page-parent').length > 0) {
				var $li = $('.nav > ul > li.current-page-parent'),
					newH = $li.find('ul').outerHeight(true);
				$li.addClass('active').find('.subsub').css({ 'max-height': newH });
			}
		}
	}

	// eventpagina
	function minHeightEventPage() {
		if (Modernizr.mq('(min-width: 768px)') && $('#event').length > 0) {
			setTimeout(function () {
				var minHeight = $('.event-page .content').outerHeight(true);
				$('.event-page').css({ 'min-height': minHeight });
			}, 100);
		}
	}
	minHeightEventPage();

	// albumpagina
	function minHeightAlbumPage() {
		if (Modernizr.mq('(min-width: 768px)') && $('#album').length > 0) {
			setTimeout(function () {
				var minHeight = $('#detail .js-aside').outerHeight(true);
				$('#detail .content').css({ 'min-height': minHeight + 90 });
			}, 100);
		}
	}
	minHeightAlbumPage();

	// faq
	function openCloseFaqAnswer() {
		if ($('#faq').length > 0) {
			$('.faq-item > h3').on('click', function (e) {
				e.preventDefault();

				var $item = $(this).closest('.faq-item');

				if ($item.is(':not(.open)'))
					$('.faq-item.open').removeClass('open').find('.faq-answer').removeAttr('style');

				var $answer = $item.find('.faq-answer'),
					heightAnswer = $answer.children('.inner').outerHeight(true);

				if ($item.hasClass('open')) {
					$answer.css({ 'maxheight': '0' });
					setTimeout(function () {
						$item.removeClass('open').find('.faq-answer').removeAttr('style');
					}, 300);
				} else {
					$item.addClass('open');
					$answer.css({ 'max-height': heightAnswer });
					if (Modernizr.mq('(max-width: 1023px)')) {
						setTimeout(function () {
							var scrollTop = $item.position().top;
							scrollTop += 63;
							$("body, html").animate({ scrollTop: scrollTop + 'px' });
						}, 300);
					}
				}
			});
		}
	}
	openCloseFaqAnswer();

	// Sticky footer
	function stickyFooter() {
		if (Modernizr.mq('(min-width: 768px)')) {
			setTimeout(function () {

				var mainHeight = $('.js-main').outerHeight(true),
					headerHeight = $('.js-header').outerHeight(true),
					footerHeight = $('.js-footer').outerHeight(true),
					windowHeight = $(window).outerHeight(true);
				if (mainHeight < (windowHeight - footerHeight)) {
					$('.js-main').css({ 'min-height': windowHeight - headerHeight - footerHeight });
				}
			}, 100);
		}
	}
	stickyFooter();

	// slider 'over paard'
	function addSlider() {
		//console.log('add slider');
		if (Modernizr.mq('(min-width: 768px)') && $('.slide-pager').length > 0) {
			$('.slide-pager').jCarouselLite({
				btnNext: "#slide-next",
				btnPrev: "#slide-prev",
				circular: true,
				visible: 3,
				//responsive: true,
				//autoWidth: true
			});
		}
	}
	if ($('.slide-pager li').length > 3) {
		addSlider();
	} else {
		$('#slide-next').remove();
		$('#slide-prev').remove();
	}

	function reAddSlider() {
		$('.slide-pager').removeAttr('style');
		$('.slide-pager > ul').removeAttr('style');
		$('.slide-pager > ul > li').removeAttr('style');
		$(".slide-pager").trigger("endCarousel");
		$('#slide-next', '#slide-prev').unbind('click');
		addSlider();
	}

	/* === VIDEOS === */
	function muteVideo() {
		var elements = document.getElementsByClassName('mute');
		for (var i = 0; i < elements.length; i++) {
			elements[i].muted = 'muted';
		}
	}

	function centerScaleElem($element) {
		//console.log($element);
		$element.css('width', '100%');
		var heightVideoInner = $element.parents('.video-inner').outerHeight(true),
			heightElem = $element.outerHeight(true);
		$element.removeAttr('style').removeAttr('width').removeAttr('height');
		if (heightElem <= heightVideoInner) {
			$element.css({ 'width': 'auto', 'height': heightVideoInner });
			var elemWidth = $element.width(),
				marginLeft = elemWidth / 2,
				marginLeft = marginLeft - (2 * marginLeft);
			$element.css({ 'margin-left': marginLeft, 'left': '50%' });
		} else {
			$element.css({ 'width': '100%' });
			var marginTop = heightElem / 2,
				marginTop = marginTop - (2 * marginTop);
			$element.css({ 'margin-top': marginTop, 'top': '50%' });
		}
	}

	function loadVideo($element, $video) {
		//console.log($element);
		var src = $video.src,
			htmlVideo = '<video id="main-menu-video" class="mute" autoplay loop><source src="' + src + '" type="video/mp4"></video>';
		$element.prepend(htmlVideo);
		var vid = document.getElementById('main-menu-video');
		vid.addEventListener('loadeddata', function () {
			if (vid.readyState == 4 || vid.readyState == 3 || vid.readyState == 2) {
				$('#main-menu-video').parents('.video').find('.video-loader').remove();
				centerScaleElem($('#main-menu-video'));
				$('#main-menu-video').addClass('loaded');
				muteVideo();
			}
		});
	}

	function loadMenuVideo() {
		var $element = $('#main-menu .video .video-inner'),
			src = $element.data('src');
		//console.log(src);
		if (src != '' && typeof src != 'undefined' && !$element.hasClass('loaded')) {
			var $video = { el: $element, src: src };
			loadVideo($element, $video);
		}
	}
	//loadMenuVideo();

	// MAIN-MENU
	var mainmenu = false,
		setScrollTop = 0;
	function openMainmenu() {
		if (!mainmenu) {
			var $mainmenu = $('#main-menu'),
				$btnOpen = $('.header a.menu'),
				$btnClose = $('#main-menu .close');
			$btnOpen.on('click', function (e) {
				e.preventDefault();
				if (!$mainmenu.hasClass('active')) {
					setScrollTop = $(window).scrollTop();
					$('body').addClass('fixed');
					$('#container').css({ 'position': 'fixed', 'margin-top': -Math.abs(setScrollTop) });
					$mainmenu.show().find('.inner-content').css({ 'height': '100%' });
					$mainmenu.addClass('active');
					centerScaleElem($('.video-inner img'));
					$mainmenu.find('.menu-search').find('input[type="text"]').focus();
					if (Modernizr.mq('(min-width: 1024px)')) {
						// load content:
						loadMenuVideo();
						centerScaleElem($('.video-inner video'));
						// set height menu-content
						$('.menu-content').height($(window).height() - $('.menu-header').outerHeight(true) - $('.menu-search').outerHeight(true) - $('.menu-footer').outerHeight(true) - 60);
					}
				}
				$('body').icons.init('.svg-icon');

				window.location.hash = 'menu';

				openActiveSubItem();
			});
			$btnClose.on('click', function (e) {
				e.preventDefault();
				if ($mainmenu.hasClass('active')) {
					$mainmenu.find('.inner-content').css({ 'height': 0 });
					$mainmenu.hide().removeClass('active');
					$('body').removeClass('fixed');
					$('#container').removeAttr('style');
					$(window).scrollTop(setScrollTop);
					window.location.hash = '';
				}
			});
			mainmenu = true;
		}
	}
	openMainmenu();

	// SEARCH
	var search = false,
		setScrollTop = 0;
	function openSearch() {
		if (!search) {
			var $searchDiv = $('#search'),
				$btnOpen = $('.header a.search'),
				$btnClose = $('#search .close');
			$btnOpen.on('click', function (e) {
				e.preventDefault();
				if (!$searchDiv.hasClass('active')) {
					setScrollTop = $(window).scrollTop();
					$('body').addClass('fixed');
					$('#container').css({ 'position': 'fixed', 'margin-top': -Math.abs(setScrollTop) });
					$searchDiv.show().find('.inner-content').css({ 'height': '100%' });
					$searchDiv.addClass('active');
					// set height overlay
					var newHeight = $searchDiv.find('.content').height() + $searchDiv.find('.header').height() + 30;
					if ($('.scroll').height() < newHeight) {
						$searchDiv.find('.scroll > .img, .scroll > .overlay').height(newHeight);
					}
					//console.log($searchDiv.find('input[type="text"]'));
					$searchDiv.find('input[type="text"]').focus();
				}
				$('body').icons.init('.svg-icon');
			});
			$('#search .close, #search .overlay').on('click', function (e) {
				e.preventDefault();
				if ($searchDiv.hasClass('active')) {
					$searchDiv.find('.inner-content').css({ 'height': '0%' });
					$searchDiv.hide().removeClass('active');
					$('body').removeClass('fixed');
					$('#container').removeAttr('style');
					$(window).scrollTop(setScrollTop);
				}
			});
			search = true;
		}
	}
	openSearch();

	// Load video:
	var getCookie = function (name) {
		var match = document.cookie.match(new RegExp('(^| )' + name + '=([^;]+)'));
		if (match) return match[2];
	}

	var $video_on = false;// = YT off
	// // console.log('cookie_settings: ')
	// // console.log(getCookie('cookie_settings'));
	// // console.log(getCookie('cookie_settings').indexOf('tracking'));

	// //if cookie_settings is set and not = default
	if (typeof getCookie('cookie_settings') != 'undefined' && getCookie('cookie_settings').indexOf('tracking') >= 1) {
		$video_on = true;// = YT on
	}

	// console.log($video_on)

	var loadVideo = {
		$play: $('.js-video-play'),
		$close: $('.js-video-close'),

		open: function ($this, $btn) {
			if (!$this.hasClass('is-active')) {
				$this.addClass('is-active');
				var videoId = $this.find('.js-video').data('target'),
					type = $this.data('type'),
					w = $this.find('.load-image').outerWidth(true),
					h = $this.find('.load-image').outerHeight(true);
				//vimeo not used yet in rows
				var $embed = type == 'vimeo'
					? '<iframe type="text/html" width="' + w + '" height="' + h + '" src="//player.vimeo.com/video/' + videoId + '" webkitallowfullscreen mozallowfullscreen allowfullscreen frameborder="0" wmode="transparent">'
					: '<iframe id="ytplayer" type="text/html" width="' + w + '" height="' + h + '" src="//www.youtube.com/embed/' + videoId + '?enablejsapi=1&autoplay=1&rel=0&showinfo=0&color=white&wmode=transparent" frameborder="0" wmode="transparent" allowfullscreen>';

				// change if Vimeo is allowed as well.
				if ($video_on == false) {
					// $embed = '<div class="js-cookie-btn eagerly-tools-cookie-blocked" data-embed="youtube"><span>'+ cookieData.yt.videoPlayerWarning +'</span><div class="warning-background"></div>';
					$embed = '<div class="js-cookie-btn eagerly-tools-cookie-blocked"><span>Je cookie instellingen blokkeren Youtube.<br />Pas <a href="#" class="">je instellingen</a> aan om gebruik te maken van Youtube.</span><div class="warning-background"></div>';
				}

				$this.find('.embed').html($embed);
				$this.find('.js-cookie-btn').click(function (e) {
					e.preventDefault();
					$('#eagerly-tools-cookie-btn').trigger('click');
				});

				setTimeout(function () {
					$this.find('.js-video').show();
					setTimeout(function () {
						$this.find('.js-video').addClass('show');
						$this.find('.btn-play').fadeOut();
						if (typeof $this.find('iframe')[0] !== 'undefined') {
							$this.find('iframe')[0].src += "&autoplay=1";
						}
					}, 10);
				}, 600);
			}
		},

		close: function ($this, $close) {
			if ($this.hasClass('is-active')) {
				$this.find('.js-video').removeClass('show');
				$this.find('.btn-play').fadeIn();
				setTimeout(function () {
					$this.removeClass('is-active');
					$this.find('.embed').find('iframe').remove();
				}, 500);
			}
		},

		init: function () {

			loadVideo.$play.on('click', function (e) {
				e.preventDefault();
				var $this = $(this).parents('.js-video-container'),
					$btn = $(this);
				loadVideo.open($this, $btn);
			});

			loadVideo.$close.on('click', function (e) {
				e.preventDefault();
				var $this = $(this).parents('.js-video-container'),
					$close = $(this);
				loadVideo.close($this, $close);
			});

		}
	};
	loadVideo.init();

	// Scroller:
	var scrollTimer = false;
	$(window).scroll(function () {
		if (Modernizr.raf) {
			clearTimeout($.data(this, 'timer'));
			if (scrollTimer == false) {
				scrollTimer = true;
				scroller.RAF.start();
			}
			$.data(this, 'timer', setTimeout(function () {
				scrollTimer = false;
				scroller.RAF.stop();
			}, 100));
		} else {
			scroller.RAF.loop();
		}
	});

	// switch grid / resize functions
	resolution.Switch = function (size) {
		if (resolution.first == true) {
			resolution.first = false;

			_resize.video($('.the_content iframe'), [16, 9]);

			setTimeout(function () { scroller.init(true); }, 100);

		} else {

			openFilter();
			openSubmenuItem();
			openSubmenuItemMobileNav();
			minHeightEventPage();
			minHeightAlbumPage();
			stickyFooter();
			reAddSlider();
			mediaCarouselFunc(true);
			loadVideo.init();
			heroGallery();

			_resize.video($('.the_content iframe'), [16, 9]);
			$('body').icons.init('.svg-icon');

			setTimeout(function () { scroller.init(true); }, 100);
		}
	}

	var resizeTimeout;
	$(window).resize(function () {
		clearTimeout(resizeTimeout);
		resizeTimeout = setTimeout(function () {
			resolution.Set();
		}, 100);
	});

	resolution.orientation = function () {

	}

	window.addEventListener('orientationchange', resolution.orientation);

	resolution.Set();



	// SVG Icons
	$('body').icons({
		svg: '/wp-content/themes/paard/assets/img/sprite.svg',
		ready: function (prop) {
			//console.log(prop);
		}
	});
	$('body').icons.init('.svg-icon');

	// Media caroussel
	$(document).on('click', '#media_caroussel .bx-wrapper .bx-controls .bx-controls-direction .bx-next', function (e) {
		e.preventDefault();
		mediaCarousel.goToNextSlide();
	});
	$(document).on('click', '#media_caroussel .bx-wrapper .bx-controls .bx-controls-direction .bx-prev', function (e) {
		e.preventDefault();
		mediaCarousel.goToPrevSlide();
	});
	$(document).on('click', '#album ul li', function (e) {
		if ($(window).width() >= 768) {
			$('#media_caroussel').addClass('active');
			var slide = $(this).attr('data-target') - 1;
			$('#media_caroussel ul li').removeClass('active');
			$('#media_caroussel ul li').eq(slide).addClass('active');
			mediaCurrentSlide = slide;
			mediaCarouselFunc(false);
			lockScroll(true);
		}
	});
	$(document).on('click', '#media_caroussel .bx-wrapper .bx-controls .close, #media_caroussel_bg', function (e) {
		$('#media_caroussel').removeClass('active');
		$('#media_caroussel_bg, #media_caroussel').stop().show().animate({ 'opacity': 0 }, 800, function () {
			$(this).hide();
			$('#media_caroussel_cont').hide();
			lockScroll(false);
			mediaCarouselStat = 'hide';
		});
	});
	$(document).keydown(function (e) {
		if ($('#media_caroussel').hasClass('active')) {
			if (e.keyCode == 37) { // left
				e.preventDefault();
				mediaCarousel.goToPrevSlide();
			} else if (e.keyCode == 39) { // right
				e.preventDefault();
				mediaCarousel.goToNextSlide();
			}
		}
	});

	// cookie
	$('.cookie-btn.toestaan').click(function () {
		$('#cookiemelding').animate({ 'bottom': '-100px' }, 600);
		$('#cookiemelding').delay(500).hide(0);
		var date = new Date();
		date.setTime(date.getTime() + (50 * 24 * 60 * 60 * 1000));
		var expires = "; expires=" + date.toGMTString();
		document.cookie = 'cookie=yes' + expires + '; path=/'
	});
	$('#cookiemelding').delay(2000).animate({ 'bottom': '0px' }, 600);

	// read cookie
	function readCookie(name) {
		var nameEQ = name + "=";
		var ca = document.cookie.split(';');
		for (var i = 0; i < ca.length; i++) {
			var c = ca[i];
			while (c.charAt(0) == ' ') c = c.substring(1, c.length);
			if (c.indexOf(nameEQ) == 0) return c.substring(nameEQ.length, c.length);
		}
		return null;
	}
	if (readCookie('cookie') != null) {
		$('#cookiemelding').hide();
	}

	// [placeholder]
	if (!Modernizr.input.placeholder) {
		$('[placeholder]').focus(function () {
			var input = $(this);
			if (input.val() == input.attr('placeholder')) {
				input.val('');
				input.removeClass('ph');
			}
		}).blur(function () {
			var input = $(this);
			if (input.val() == '' || input.val() == input.attr('placeholder')) {
				input.addClass('ph');
				input.val(input.attr('placeholder'));
			}
		}).blur();
		$('[placeholder]').parents('form').submit(function () {
			$(this).find('[placeholder]').each(function () {
				var input = $(this);
				if (input.val() == input.attr('placeholder')) {
					input.val('');
				}
			});
		});
	}

	if ($('#newsletter form').length > 0) {
		$('#newsletter form').submit(function (e) {
			e.preventDefault();
			var _btn = $(this).find('.btn--submit'); //is not defined
			_btn.fadeOut(100);

			$.ajax({
				url: customData.ajaxURL,
				data: $(this).serialize(),
				dataType: 'json',
				method: 'POST',
			})
				.done(function (data) {
					var curText = _btn.attr('value');
					if (data.success) {
						_btn.click(function (e) { e.preventDefault(); });
					}
					_btn.css('cursor', 'default');
					_btn.css('background-color', $('#detail .content h2.big').css('color'));
					_btn.attr('value', data.message);
					_btn.fadeIn();
					if (!data.success) {
						setTimeout(function () {
							_btn.fadeOut(function () {
								_btn.css('cursor', 'pointer');
								_btn.css('background-color', '#000000');
								_btn.attr('value', curText);
								_btn.fadeIn();
							});
						}, 3000);
					}
				});
		});
	}

	// [title]
	$('[title]').each(function () {
		$(this).data('original-title', $(this).attr('title'));
	}).hover(function () {
		$(this).attr('title', '')
	}, function () {
		$(this).attr('title', $(this).data('original-title'));
	});

	// [buttons]
	$('[data-href]').click(function (e) {
		var target = $(e.target);
		if (target.not('a')) {
			if ($(this).attr('data-window') == 'new') {
				window.open($(this).attr('data-href'));
			} else {
				window.location.href = $(this).attr('data-href');
			}
			return false;
		}
	});

	$('.get-all-quotes').click(function (e) {
		e.preventDefault();
		var _this = $(this);
		_this.animate({ opacity: 0 }, 300, function () {
			_this.remove();
		});
		$('html, body').animate({
			scrollTop: $('.quote-items').offset().top
		}, 300);
		$('.quote-items').animate({ opacity: 0 }, 500, function () {
			$.ajax({
				url: customData.ajaxURL,
				data: { action: 'paard_get_all_quotes', employee: _this.attr('data-employee') }
			})
				.done(function (data) {
					if (data) {
						$('.quote-items').html(data);
						$('.quote-items').animate({ opacity: 1 }, 500, function () {
						});
					}
				});
		});
	});

	// init_news_pagination();
	// init_albums_pagination();


	window.addEventListener("hashchange", hashChange);
	function hashChange() {
		if ('#menu' == location.hash && !$('#main-menu').hasClass('active')) {
			$('.header a.menu').click();
		} else if ('' == location.hash && $('#main-menu').hasClass('active')) {
			$('#main-menu .close').click();
		}
	}
	if ('' != location.hash) {
		hashChange();
	}

	if ($('#faq').length > 0 && location.hash != '') {
		var faq_slug = location.hash.substring(1);
		if ($('#faq .faq-item[data-faq="' + faq_slug + '"]').length > 0) {
			var pos = $('#faq .faq-item[data-faq="' + faq_slug + '"]').position();
			$('#faq .faq-item[data-faq="' + faq_slug + '"] h3').click();
			setTimeout(function () {
				$('html, body').scrollTop(pos.top);
			}, 100);
		}
	}
	// 2022-07-05: disable ajax ticket status refresh in favour of 10 min cache of the single event page, for performance/server load reasons.
	if ($('.js-ticket-btn').length > 0 && $('.js-ticket-btn').data('event') != '') {
		getEventStatus($('.js-ticket-btn').data('event'), $('.js-ticket-btn').data('status'));
	}

	if ($('form.businessclub_form').length > 0) {
		$('form.businessclub_form').submit(function (e) {
			e.preventDefault();
			var $this = $(this);
			var $container = $this.closest('.content');
			var $btn = $this.find('input[type="submit"]');
			$btn.fadeOut(100);

			$.ajax({
				url: customData.ajaxURL,
				data: $(this).serialize(),
				dataType: 'json',
				method: 'POST',
			})
				.done(function (data) {
					var json = data;
					var $message = '';
					if ('object' != typeof json) {
						json = $.parseJSON(json);
					}
					if ('undefined' != typeof json.message) {
						$message = json.message;
					}
					if ('undefined' != typeof json.errors && json.errors.length > 0) {
						$this.find('.error_message').text($message).show();
						for (var k in json.errors) {
							var $field = json.errors[k];
							var $input = $this.find('input[name="' + $field + '"],textarea[name="' + $field + '"]');
							if ($input.length > 0) {
								$input.addClass('error');
							}
						}
						$btn.fadeIn(100);
					} else if ('undefined' != typeof json.success) {
						// success
						$container.find('> *:not(.success-image)').remove();
						$container.find('.success-image .text').html($message);
						$container.find('.success-image').removeClass('hide');
					}
				});
		});
	}
});

function init_news_pagination() {
	$('#pagination.news-pagination a').click(function (e) {
		e.preventDefault();
		var _this = $(this);
		$('#news').animate({ opacity: 0 }, 500, function () {
			$.ajax({
				url: customData.ajaxURL,
				data: { action: 'paard_get_news_pagination', page: _this.attr('data-page') }
			})
				.done(function (data) {
					if (data) {
						$('#news').html(data);
						$('#news').animate({ opacity: 1 }, 500);
						$('#news').icons.init('.svg-icon');
					}
				});
		});
	});
}

function init_albums_pagination() {
	$('#pagination.album-pagination a').click(function (e) {
		e.preventDefault();
		var _this = $(this);
		$.ajax({
			url: customData.ajaxURL,
			data: { action: 'paard_get_albums_pagination', page: _this.attr('data-page') },
			dataType: 'json',
			beforeSend: function () {
				$('#albums, #pagination').animate({ opacity: 0 }, 500);
			}
		})
			.done(function (data) {
				if (data) {
					var url = document.location.protocol + '//' + document.location.hostname + document.location.pathname;
					if (/page\/([1-9]+)/.test(url)) {
						url = url.replace(/page\/([1-9]+)/, 'page/' + _this.attr('data-page'));
					} else {
						url = url + 'page/' + _this.attr('data-page')
					}
					window.history.replaceState({}, document.title, url);
					$('#albums').html(data.albums_html);
					$('#albums').animate({ opacity: 1 }, 500);
					$('#pagination').html(data.pagination_html);
					$('#pagination').animate({ opacity: 1 }, 500);
					$('#pagination').icons.init('.svg-icon');
					$('html').scrollTop(0);
				}
			});
	});
}

//switch grid / resize functions
resolution.Set = function () {
	var newResolution;
	if (Modernizr.mq('(max-width: 767px)')) {
		newResolution = 'mobile';
	} else if (Modernizr.mq('(max-width: 1160px)')) {
		newResolution = 'tablet';
		if (Modernizr.mq('(max-width: 1023px)')) {
			newResolution = ' portrait';
		}
	} else {
		newResolution = 'desktop';
		if (Modernizr.mq('(min-width: 1440px)')) {
			newResolution += ' wide';
		}
	}
	if (Modernizr.mq('(min-width: 1800px)') && $(window).height() > 900) {
		newResolution += ' big-carousel';
	}
	// if (_browserCheck.isTablet() || _browserCheck.isMobile()) {
	// 	newResolution += ' touch';
	// }
	if (navigator.platform.toUpperCase().indexOf('MAC') != -1) {
		newResolution += ' mac';
		//console.log('mac!');
	}
	if ($('html').hasClass('no-borderradius')) { newResolution += ' IE8'; }
	if (newResolution != resolution.current) {
		var resolutionClasses = ['mobile', 'tablet', 'desktop', 'wide', 'portrait', 'IE8', 'touch', 'big-carousel'];
		$.each(resolutionClasses, function (i, v) {
			$('html').removeClass(v);
		})
		resolution.current = newResolution;
		$('html').addClass(resolution.current);
		resolution.Switch(resolution.current)
	}
}
$('#setGrid').ready(function () {
	resolution.Set;
});

function getEventStatus($event, $currentStatus) {
	$.ajax({
		url: customData.ajaxURL,
		dataType: 'json',
		data: { action: 'get_ticket_status', event: $event },
		cache: false
	}).done(function (data) {
		if (typeof data.status != 'undefined' && data.status != $currentStatus) {
			var html = '';
			if (data.ticket_url !== false) {
				var target = '';
				if (data.ticket_url.indexOf('paard.nl') == -1) {
					target = ' target="_blank" ';
				}
				html = '<a ' + target + ' href="' + data.ticket_url + '" class="btn btn--' + data.status + '">' + data.label_large + '</a>';
			} else {
				html = '<a class="btn btn--' + data.status + ' btn--ghost">' + data.label_large + '</a>';
			}
			if ($currentStatus != 'waitinglist') {
				$('.js-ticket-btn').replaceWith(html);
			}
		}
	});
}


var _resize = {
    columnsHeight: function($columns, rows) {
        if (typeof $columns != 'object') {
            $columns = $($columns);
        }
        $columns.css({'height' : 'auto'}).removeClass('resized');
        var itemsInRow = rows;
            column = 0;
            rowHeight = 0,
            first = true,
            total = $columns.length;
        if (rows == false || typeof itemsInRow == 'undefined') {
            itemsInRow = Math.floor($columns.parent().width() / $columns.first().outerWidth(true));
        }
        $columns.each(function(i) {
           column++;
           var itemHeight = $(this).height();
           if (rowHeight < itemHeight) {
               rowHeight = itemHeight;
           }
           if (column >= itemsInRow || i == total - 1) {
               column = 0;
               $(this).prevAll(':not(.resized)').addClass('resized').css({'height' : rowHeight});
               $(this).addClass('resized').css({'height' : rowHeight});
               rowHeight = 0;
           }
        });
    },
    video: function($video, $proportion) {
        if (typeof $video != 'object') {
            $video = $($video);
        }
        $video.css({'height' : 'auto', 'width' : '100%'});
        var width = $video.width(),
            height = Math.round(width / $proportion[0] * $proportion[1]);
        $video.css({'height' : height});
    }
}
function forceInitJwplayer() {
	fetch('//content.jwplatform.com/players/eQBZ1j9w-HycAYKe3.js')
  .then(response => response.text())
  .then((body) => {
		var jwConfig = JSON.parse(body.split("var jwConfig = ")[1].split("; // end config")[0]);
		var playerDiv = body.split(`jwplayer("`)[1].split(`").setup`)[0];
		if ('undefined' != typeof jwplayer) {
			jwplayer(playerDiv).setup(jwConfig);
		}
  });

}


function elementReady(selector) {
  return new Promise(function(resolve, reject) {
    var el = document.querySelector(selector);
    if (el) {
      resolve(el);
      return
    }
    new MutationObserver(function(mutationRecords, observer) {
      Array.from(document.querySelectorAll(selector)).forEach(function(element) {
        resolve(element);
        observer.disconnect();
      });
    })
      .observe(document.documentElement, {
        childList: true,
        subtree: true
      });
  });
}

if (document.body.contains(document.querySelector(".youtube"))) {
	elementReady(".youtube > div").then(function () {
		forceInitJwplayer();
	});
}


// Makes the sticky cta apear when button is out of view
const tile = document.querySelector('.sticky-cta-js');
const btn = document.querySelector('.ticket-btn-js');

window.addEventListener('scroll', () => {
	if (null != btn) {
		const btnRect = btn.getBoundingClientRect();
		if (btnRect.bottom < 0) {
			tile.style.transform = 'none';
		} else {
			tile.style.transform = 'translateY(100%)';
		}
	}
});
